import { render, staticRenderFns } from "./try-catch.vue?vue&type=template&id=09d7aef4&scoped=true"
import script from "./try-catch.vue?vue&type=script&lang=js"
export * from "./try-catch.vue?vue&type=script&lang=js"
import style0 from "./try-catch.vue?vue&type=style&index=0&id=09d7aef4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d7aef4",
  null
  
)

export default component.exports